<ng-template appChartHost></ng-template>
